import React from 'react'

export default function Eyes() {
  return (
    <div>
      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 0.990234L20 18.9902" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9.58396 8.57812C9.20868 8.95314 8.99775 9.46188 8.99756 9.99242C8.99737 10.523 9.20795 11.0318 9.58296 11.4071C9.95798 11.7824 10.4667 11.9933 10.9973 11.9935C11.5278 11.9937 12.0367 11.7831 12.412 11.4081" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.363 3.35529C9.22042 3.11002 10.1082 2.98713 11 2.99029C15 2.99029 18.333 5.32329 21 9.99029C20.222 11.3513 19.388 12.5143 18.497 13.4783M16.357 15.3393C14.726 16.4393 12.942 16.9903 11 16.9903C7 16.9903 3.667 14.6573 1 9.99029C2.369 7.59529 3.913 5.81529 5.632 4.64929" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    </div>
  )
}
